import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { sessionEvents } from "../events/sessionEvents";

/**
 * Clears cached job-list and per-job queries on `auth:logout` and on
 * `project:switching`. PRD-001 DoD: jobs are scoped to (user × project);
 * leaving either context must clear what the user previously saw, both
 * for correctness (a new credential may belong to a different user) and
 * for hygiene (avoid flashing the prior user's job names while the new
 * fetch is in flight).
 *
 * Mounted once at app root inside the QueryClientProvider, alongside
 * IdentityCacheCleaner and ProjectCacheCleaner.
 */
export function JobsCacheCleaner() {
    const queryClient = useQueryClient();
    useEffect(() => {
        const offLogout = sessionEvents.on("auth:logout", () => {
            queryClient.removeQueries({ queryKey: ["jobs"] });
        });
        const offSwitch = sessionEvents.on("project:switching", () => {
            queryClient.removeQueries({ queryKey: ["jobs"] });
        });
        return () => {
            offLogout();
            offSwitch();
        };
    }, [queryClient]);
    return null;
}
